import JobFormModal from "./JobFormModal";

export default function JobEdit(props) {
    return (
        <JobFormModal
            mode="edit"
            jobId={props.job_id}
            isModalVisible={props.isModalVisible}
            handleShowB={props.handleShowB}
        />
    );
}
